import { Routes, Route } from "react-router-dom";
import Products from "./Products";
import ProductCreateEdit from "./ProductCreateEdit";
import ProductDetails from "./ProductDetails";
import ProductsIdtf from "./ProductsIdtf";
import ProductsAdn from "./ProductsAdn";
import ProductsNstr from "./ProductsNstr";

const index = () => {
	return (
		<Routes>
			<Route index element={<Products />} />
			<Route path='/create' element={<ProductCreateEdit />} />
			<Route path='/:id/edit' element={<ProductCreateEdit />} />
			<Route path='/:id/details' element={<ProductDetails />} />
			<Route path='/idtf' element={<ProductsIdtf />} />
			<Route path='/adn' element={<ProductsAdn />} />
			<Route path='/nstr' element={<ProductsNstr />} />
		</Routes>
	);
};

export default index;
